import { V3 } from '../../api_request';
import { get } from 'lodash';
import URLHelpers from '../../shared/url_helpers';

import { IFollow } from '@reverbdotcom/commons';
import { IFindFollowResponse } from '../../../schemas/core-schema';
import { flashError } from '@reverbdotcom/commons/src/flash';
import { getLink } from '../../../reverb-js-common/hash_util';

export default class FollowService {
  static add(params): JQueryPromise<IFindFollowResponse> {
    const req = V3.post(
      URLHelpers.myFollowsSearchPath(),
      JSON.stringify(params),
      { contentType: 'application/json' },
    );
    return req.fail((err) => { this.fail(err); });
  }

  static remove(follow: IFollow): JQueryPromise<IFollow> {
    const req = V3.destroy(getLink(follow, 'self'));
    req.fail(err => this.fail(err));

    return req;
  }

  static removeAlert(follow: IFollow): JQueryPromise<IFollow> {
    const req = V3.destroy(getLink(follow, 'alert'));
    req.fail(err => this.fail(err));

    return req;
  }

  static fetch(params): JQueryPromise<IFindFollowResponse> {
    const req = V3.get(URLHelpers.myFollowsSearchPath(), params);
    req.fail((_xhr, status, err) => { throw new Error(`failed to fetch follows - status: ${status}, err: ${err}`); });

    return req;
  }

  private static fail(error) {
    flashError(get(error, 'responseJSON.message'));
    throw new Error(get(error, 'responseJSON.message'));
  }
}
